// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jVp8","toggleWrap":"styles_toggleWrap__2FKYJ","content":"styles_content__2hwq5","selectAreaCode":"styles_selectAreaCode__Ki8pl"};